export const MOBILE_WIDTH = 767;

export const API_BASE_URL = 'http://vzor.r.smglab.ru/api/';

export function getDisplayWidth() {
    let width = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
    return width;
}

export function getLang() {
    return $('html').attr('lang');
}


// WEBPACK FOOTER //
// ./js/utils/helpers.js